import { getSession } from "../global";
import { createSlice } from "@reduxjs/toolkit";

const userInfo = () => {
    return getSession('userInfo');
};
const accounts = () => {
    return getSession('subaccounts') ? [...new Set(getSession('subaccounts').map(x => x.accountNo.toUpperCase()))] : [];
};
const subaccounts = () => {
    return getSession('subaccounts');
};
const types = () => {
    return getSession('types');
};

const services = () => {
    return getSession('services');
};

const codAmountLimit = () => {
    return getSession('codAmountLimit');
};

const AppSlice = createSlice({
    name: 'appData',
    initialState: {
        userInfo: userInfo(),
        accounts: accounts(),
        subaccounts: subaccounts(),
        services: services(),
        types: types(),
        loading: false,
        destinations: [],
        bannerDisplayed: true,
        codAmountLimit: codAmountLimit()
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload.data
        },
        setDestinations: (state, action) => {
            state.destinations = action.payload.data
        },
        setBannerDisplayed: (state, action) => {
            state.bannerDisplayed = action.payload.data
        }
    }
});

export default AppSlice.reducer;
export const { setLoading, setDestinations, setBannerDisplayed } = AppSlice.actions;